export default __webpack_public_path__ + "static/media/sale-new.dec9eb1b.png";